import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const faqKeys = [
  { qKey: 'faq_1_q', aKey: 'faq_1_a' },
  { qKey: 'faq_2_q', aKey: 'faq_2_a' },
  { qKey: 'faq_3_q', aKey: 'faq_3_a' },
  { qKey: 'faq_4_q', aKey: 'faq_4_a' },
  { qKey: 'faq_5_q', aKey: 'faq_5_a' },
  { qKey: 'faq_6_q', aKey: 'faq_6_a' },
  { qKey: 'faq_7_q', aKey: 'faq_7_a' },
  { qKey: 'faq_8_q', aKey: 'faq_8_a' },
];

export default function HomeFAQ() {
  const { t } = useTranslation();
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-24 bg-[#F8F3FB] px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-[#4F2D63] uppercase tracking-widest mb-3">
            Got Questions?
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('faq_title')}
          </h2>
          <p className="text-base text-gray-500">
            {t('faq_subtitle')}
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3" itemScope itemType="https://schema.org/FAQPage">
          {faqKeys.map(({ qKey, aKey }, idx) => (
            <div
              key={qKey}
              className={`bg-white rounded-xl border transition-all duration-200 overflow-hidden ${
                openIdx === idx ? 'border-[#E9D9F2]' : 'border-[#E9D9F2] hover:border-[#DBB6EE]'
              }`}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
              >
                <span
                  className="text-base font-semibold text-gray-900 leading-snug"
                  itemProp="name"
                >
                  {t(qKey)}
                </span>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${openIdx === idx ? 'bg-[#E9D9F2] rotate-45' : 'bg-gray-100'}`}>
                  <i className="ri-add-line text-gray-600 text-sm"></i>
                </div>
              </button>

              <div
                className={`transition-all duration-300 ${openIdx === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <p
                  className="px-6 pb-5 text-sm text-gray-600 leading-relaxed"
                  itemProp="text"
                >
                  {t(aKey)}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* More questions link */}
        <div className="text-center mt-10">
          <p className="text-sm text-gray-500 mb-4">Have more questions?</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/faq"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border-2 border-gray-200 text-gray-700 font-semibold text-sm hover:border-gray-300 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              View all FAQs
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-[#4F2D63] text-white font-semibold text-sm hover:bg-[#3E234F] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-chat-3-line"></i>
              Ask us directly
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
